import React, {useMemo} from 'react';
import cn from 'classnames';

import {useSearchMgrInstance} from 'coreHooks';

import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import ShowOrHideOnBreakpoint from 'brandComponents/Responsive/ShowOrHideOnBreakpoint';
import {FIRST_PAGE} from 'brandConstants';

import {ISearchHitsSubcomponent} from './ISearchHitsSubcomponent';

const OffsetTile = ({index, page, pageSize}: ISearchHitsSubcomponent) => {
	const {
		searchType,
		searchInstanceKey,
		customElements,
		customElementsConfigs,
		customElementsHideInSmallGrid
	} = useCategoryContext(true) || {};
	const searchMgr = useSearchMgrInstance({searchType, key: searchInstanceKey});
	const hasActiveFilters = searchMgr.isSomeFilterSelectedByUser() || !!searchMgr.getUserSelectedSorting();
	const customElementIncludes = useMemo(() => {
		const map = new Map();

		customElements?.items?.forEach((c, k) => {
			const productConfig = customElementsConfigs?.items?.[k];

			if (productConfig) {
				map.set(productConfig.position, {
					contentfulData: c,
					size: productConfig.size,
					height: productConfig.height,
					width: productConfig.width,
					position: productConfig.position,
					positionMOB: productConfig.positionMOB,
					sizeMOB: productConfig.sizeMOB,
					hideInSmallGrid: customElementsHideInSmallGrid,
				});
			}
		});

		return map;
	}, [customElements, customElementsConfigs, customElementsHideInSmallGrid]);
	const offset = (page - 1) * pageSize;
	const position = index + offset;
	const offsetTile = customElementIncludes?.get(`offset-tile-${position + 1}`);

	if (hasActiveFilters || page === FIRST_PAGE || !offsetTile) {
		return null;
	}

	const getClassNames = (size: number) => cn(
		'element-category-page',
		`element-category-page__width--${size}`,
		'offset-tile'
	);

	const sizeMOB = offsetTile?.sizeMOB;
	const size = offsetTile?.size;

	return (
		<>
			{typeof sizeMOB === 'number' && !offsetTile.hideInSmallGrid && sizeMOB !== 0 && (
				<ShowOrHideOnBreakpoint query="<medium" classNames={getClassNames(sizeMOB)}>
				</ShowOrHideOnBreakpoint>
			)}
			{typeof size === 'number' && size !== 0 && (
				<ShowOrHideOnBreakpoint query=">=medium" classNames={getClassNames(size)}>
				</ShowOrHideOnBreakpoint>
			)}
		</>
	);
};

export default OffsetTile;

